import * as React from 'react';
import Drawer from '@mui/material/Drawer';
import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import PrimaryButton from '../shared/button/PrimaryButton';
import { hasCookieConsent, recordCookieConsent } from '../../util/cookie-consent';

function CookieConsentDrawer() {
  const [openCookieDrawer, setOpenCookieDrawer] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!hasCookieConsent()) setOpenCookieDrawer(true);
  }, []);

  const handleCookieConsent = () => {
    recordCookieConsent();
    setOpenCookieDrawer(false);
  };

  return (
    <>
      <Drawer
        anchor={'bottom'}
        open={openCookieDrawer}
        onClose={() => {
          setOpenCookieDrawer(false);
        }}
        // Without this, the drawer's focus trap steals keyboard input from dialogs
        // stacked above it (e.g. the login/recovery modal) when it opens last.
        ModalProps={{ disableEnforceFocus: true }}
      >
        <Box display={'flex'} padding={4} justifyContent={'space-evenly'}>
          <Box display={'flex'} flexDirection={'column'} marginRight={4}>
            <Typography fontSize={20} fontWeight={'bold'} marginBottom={1}>
              Cookie Consent
            </Typography>
            <Typography>
              {`This website makes use of cookies to provide a better user experience and manage user sessions.`}
            </Typography>
            <Typography>{`By continuing to use this website you consent to the use of these cookies.`}</Typography>
          </Box>
          <Box alignSelf={'center'}>
            <PrimaryButton
              onClick={handleCookieConsent}
              sx={{
                width: '150px',
                height: '50px'
              }}
            >
              OK
            </PrimaryButton>
          </Box>
        </Box>
      </Drawer>
    </>
  );
}

export default CookieConsentDrawer;
